module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/crowd-general/crowd-general.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/crowd-general/crowd-general.component.css
// module chunks = main